import { serviceCreateClient, serviceFetchClient, serviceUpdateClient } from "../services/Client.service";
import EventEmitter from "../libs/Events.utils";
import store from "../store";
import constants from "../config/constants";
import { serviceAssociatedUsersRole } from "../services/Role.service";


export const FETCH_INIT = 'FETCH_INIT_ASSOCIATED_USERS';
export const FETCHED = 'FETCHED_ASSOCIATED_USERS';
export const FETCHED_FAIL = 'FETCHED_FAIL_ASSOCIATED_USERS';
export const FETCHED_FILTER = 'FETCHED_FILTER_ASSOCIATED_USERS';
export const FETCH_NEXT = 'FETCH_NEXT_ASSOCIATED_USERS';
export const FILTER = 'FILTER_ASSOCIATED_USERS';
export const RESET_FILTER = 'RESET_FILTER_ASSOCIATED_USERS';
export const SET_SORTING = 'SET_SORTING_ASSOCIATED_USERS';
export const SET_FILTER = 'SET_FILTER_ASSOCIATED_USERS';
export const SET_PAGE = 'SET_PAGE_ASSOCIATED_USERS';
export const CHANGE_PAGE = 'CHANGE_PAGE_ASSOCIATED_USERS';
export const CHANGE_STATUS = 'CHANGE_STATE_ASSOCIATED_USERS';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_ASSOCIATED_USERS';

export const CREATE_DATA = 'CREATE_ASSOCIATED_USERS';
export const UPDATE_DATA = 'UPDATE_ASSOCIATED_USERS';
export const DELETE_ITEM = 'DELETE_ASSOCIATED_USERS';

export function actionFetchAssociatedUsers(index = 1, sorting = {}, filter = {}, id,shouldReset = false) {
    const request = serviceAssociatedUsersRole({ index, row: sorting.row, order: sorting.order,...filter, id:id ? id :""});
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: SET_FILTER, payload: filter });
            dispatch({ type: SET_SORTING, payload: sorting });
            if (!data.error) {
                dispatch({ type: FETCHED, payload: { data: data?.data, page: index } });
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({ type: CHANGE_PAGE, payload: index - 1 });
                }
            } else {
                dispatch({ type: FETCHED_FAIL, payload: null });
            }
        });
    };
}




export function actionChangePageUsers(page) {
    return (dispatch) => {
        dispatch({ type: CHANGE_PAGE, payload: page })
    }
}


export function actionFilterUsers(value) {
    const request = null;
    return (dispatch) => {
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: FILTER, payload: data });
            dispatch({ type: FETCHED, payload: null });
        });
    };
}


export function actionChangeStatusUsers(id, status) {
    return (dispatch) => {
        dispatch({ type: CHANGE_STATUS, payload: { id, status } });
    };
}

export function actionResetFilterUsers() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageUsers(page, id) {
    const stateData = store.getState().associatedUsers;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchAssociatedUsers(serverPage + 1, sortingData, { query, query_data: queryData },id));
    }
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}

